import React from "react";
import { AutoCompleteSelect } from "../../../design-system";
import { getCities } from "../../../api/address";

export default (props) => {
  const [loading, setLoading] = React.useState(false);
  const [cities, setCities] = React.useState([]);

  // Se `defaultInputValue` existir e for válido, mas a lista `cities` estiver vazia
  // Podemos inserir ele localmente como única option inicial ou deixar limpo.
  // Como `AutoCompleteSelect` consegue apenas mostrar se a option estiver em `options`, 
  // vamos colocar o `defaultInputValue` temporariamente no state se ele não tiver id,
  // ou apenas injetar a opção selecionada vindo do pai.
  
  // Para ser fiel ao funcionamento de React-Select, a option atual precisa estar
  // na lista de `options` ou ser tratada internamente pelo componente.
  
  React.useEffect(() => {
    if (props.defaultInputValue && props.cityId) {
      setCities([{ id: props.cityId, city_name: props.defaultInputValue }]);
    }
  }, [props.defaultInputValue, props.cityId]);

  function onInputChange(value, actionMeta) {
    if (actionMeta.action === "input-change" && value.length >= 3) {
      setLoading(true);
      getCities({ city: value, uf_code: props.stateCode })
        .then((data) => {
          setCities(data);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  function onChange(e, option) {
    const valueId = e.target.value;
    const selectedCity = cities.find(c => c.id === valueId);
    
    if (props.onChange && selectedCity) {
      props.onChange(selectedCity.id, selectedCity.city_name);
    }
  }

  const options = cities.map((city) => ({
    value: city.id,
    label: city.city_name,
  }));

  return (
    <AutoCompleteSelect
      label="Cidade"
      placeholder={!props.stateCode ? "Selecione o Estado primeiro" : "Digite para buscar"}
      options={options}
      value={props.cityId}
      onChange={onChange}
      onInputChange={onInputChange}
      disabled={loading || props.disabled || !props.stateCode}
      isSearchable={true}
      error={props.error}
    />
  );
};



// WEBPACK FOOTER //
// ./src/_components/Address/CityLocation/index.jsx